import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=af635f98&scoped=true"
import script from "./PaymentGateway.vue?vue&type=script&lang=ts"
export * from "./PaymentGateway.vue?vue&type=script&lang=ts"
import style0 from "./PaymentGateway.vue?vue&type=style&index=0&id=af635f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af635f98",
  null
  
)

export default component.exports